/* Skapad av Claude Code — svd-productblock-bundle-v3 (paketkort med produktbild, 2026-07-21).
   Fork av v2 (svd-productblock-bundle-v2.js) med vikt-/prenumerationslogiken borttagen:
   - Rader = paket (variant × quantity), priser renderas server-side och röres ej.
   - Paketrader (quantity > 1) stämplas med _godispaket så SVD Paket-motorn ger
     trapprabatten i kassan — samma konvention som svd-productblock-godispaket.js.
   - GWP (sedan 2026-08-05): kortets egna gåvoval (data-gwp1/2-id från variant_X_gwp_product-
     settingsen) är facit och läggs som _gwp-rader; sektionens data-gwp-rule (produkt-
     metafältet svd.gwp_rule, v2-formatet inkl. main_variant_ids/min_main_quantity) används
     ENDAST som reserv för kort utan egna gåvoval.
   - UpCart-/tema-drawer-/SvdNotis-/upsell-popup-hanteringen är oförändrad från v2. */
(function () {
  'use strict';

  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }

  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart auto-öppnar normalt själv */ }
  }

  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') {
      new window.CartDrawer();
    }
  }

  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;
    renderDrawerSections(response);
    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  function initBundle(root) {
    if (root.__svdBundleV3Init) return;
    root.__svdBundleV3Init = true;

    var variants = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-variant]'));
    var cta      = root.querySelector('[data-bundle-cta]');
    if (!cta || variants.length === 0) return;

    var gwpGifts = [];
    try {
      var rawRule = root.getAttribute('data-gwp-rule');
      if (rawRule) {
        var parsed = JSON.parse(rawRule);
        if (parsed && Array.isArray(parsed.gifts)) gwpGifts = parsed.gifts;
        else if (parsed && parsed.gift_variant_id) gwpGifts = [parsed];
      }
    } catch (e) {
      console.warn('[svd-bundle-v3] ogiltig svd.gwp_rule', e);
    }

    var state = { selectedRow: null };

    var initialSelected = variants.find(function (v) { return v.getAttribute('data-selected') === 'true'; });
    if (initialSelected) {
      state.selectedRow = initialSelected;
    } else if (variants[0]) {
      state.selectedRow = variants[0];
      variants[0].setAttribute('data-selected', 'true');
    }
    if (state.selectedRow) selectVariant(state.selectedRow);

    function selectVariant(row) {
      state.selectedRow = row;
      variants.forEach(function (v) {
        var isSel = v === row;
        v.setAttribute('data-selected', isSel ? 'true' : 'false');
        var radio = v.querySelector('[data-bundle-radio]');
        if (radio) radio.checked = isSel;
      });
      /* GSO-dragspelet (2026-08-19): kort med stack (data-stacked) fälls ut vid val.
         Väljs ett kort UTAN stack lämnas senast öppna stacken kvar (Magbalans R5-mönstret). */
      if (row.hasAttribute('data-stacked')) {
        variants.forEach(function (v) {
          if (v.hasAttribute('data-stacked')) v.classList.toggle('is-open', v === row);
        });
      }
      /* CTA-priset (mockup R2): "Lägg i varukorgen · 529 kr" — uppdateras med valet. */
      var ctaPrice = root.querySelector('[data-bundle-cta-price]');
      if (ctaPrice) {
        var pOre = parseInt(row.getAttribute('data-price'), 10);
        if (pOre > 0) {
          var ctaCur = ctaPrice.getAttribute('data-currency') || 'SEK';
          if (ctaCur === 'SEK') {
            ctaPrice.textContent = Math.round(pOre / 100).toLocaleString('sv-SE') + ' kr';
          } else {
            /* Int. marknader (EUR/NOK/PLN): riktig valutaformatering i st f hårdkodat " kr" (Finland visade "28 kr" för 27,95 €). */
            try { ctaPrice.textContent = new Intl.NumberFormat(ctaPrice.getAttribute('data-locale') || 'fi-FI', { style: 'currency', currency: ctaCur }).format(pOre / 100); }
            catch (e) { ctaPrice.textContent = (pOre / 100).toFixed(2) + ' ' + ctaCur; }
          }
          ctaPrice.removeAttribute('hidden');
        }
      }
    }

    function addToCart() {
      if (cta.hasAttribute('disabled')) return;
      if (!state.selectedRow) return;

      var selRow = state.selectedRow;
      var qty = parseInt(selRow.getAttribute('data-quantity'), 10) || 1;
      var mainVariantId = parseInt(selRow.getAttribute('data-variant-id'), 10);
      var mainItem = { id: mainVariantId, quantity: qty };
      /* Stämpel (2026-09-18): _godispaket som standard; leksaks-PDP:n (data-stamp på
         sektionen när produkten har en svd_leksak_pdp-post) sätter _leksakspaket så
         leksaksregeln i paket-motorn (stamp: leksak) är ensam om raderna. */
      var stampKey = root.getAttribute('data-stamp') || '_godispaket';
      var stampProps = {}; stampProps[stampKey] = '1';
      if (qty > 1) mainItem.properties = stampProps;
      var items = [mainItem];

      /* Leksaks-PDP kort 3 (2026-09-13): data-lk-set = paketpostens produkter som egna
         rader, alla stämplade med sidans stämpel (_leksakspaket) — paket-motorns leksaksregel ger procenten. */
      try {
        var lkSet = JSON.parse(selRow.getAttribute('data-lk-set') || '[]') || [];
        if (lkSet.length > 1) {
          items = lkSet.map(function (id) { return { id: parseInt(id, 10), quantity: 1, properties: stampProps }; });
        }
      } catch (e) { console.warn('[svd-bundle-v3] ogiltig data-lk-set', e); }

      /* Addon (svd.addon_rule-metafältet, renderad som data-addon-* av snippeten):
         betald extraprodukt i paketet — stämplas _godispaket så paket-motorns
         kollektionsgate:ade regel kan rabattera raden till paketpriset. */
      var addonId = parseInt(selRow.getAttribute('data-addon-id'), 10);
      if (addonId > 0) {
        var addonQty = parseInt(selRow.getAttribute('data-addon-qty'), 10) || 1;
        items.push({ id: addonId, quantity: addonQty, properties: stampProps });
      }

      /* Gåvor: GSO-stackens härledda lista (data-gwp-list, N gåvor — 2026-08-19) är
         facit på stackade kort; annars kortets egna produktval (data-gwp1/2-id, renderas
         bara när gåvan är köpbar). svd.gwp_rule-metafältet är sista reserven. */
      var settingsGiftIds = [];
      try {
        var listRaw = selRow.getAttribute('data-gwp-list');
        if (listRaw) settingsGiftIds = (JSON.parse(listRaw) || []).map(function (id) { return parseInt(id, 10); }).filter(function (id) { return id > 0; });
      } catch (e) { console.warn('[svd-bundle-v3] ogiltig data-gwp-list', e); }
      if (settingsGiftIds.length === 0) {
        settingsGiftIds = ['data-gwp1-id', 'data-gwp2-id']
          .map(function (attr) { return parseInt(selRow.getAttribute(attr), 10); })
          .filter(function (id) { return id > 0; });
      }
      if (settingsGiftIds.length > 0) {
        settingsGiftIds.forEach(function (gwpId) {
          items.push({ id: gwpId, quantity: 1, properties: { '_gwp': 'true' } });
        });
      } else {
        gwpGifts.forEach(function (gift) {
          if (!gift || !gift.gift_variant_id) return;
          var gwpAllowed = !gift.subscription_only;
          if (Array.isArray(gift.main_variant_ids) && gift.main_variant_ids.length > 0) {
            var qualifies = gift.main_variant_ids.some(function (id) { return parseInt(id, 10) === mainVariantId; });
            if (!qualifies) gwpAllowed = false;
          }
          var minQty = parseInt(gift.min_main_quantity, 10);
          if (minQty > 0 && qty < minQty) gwpAllowed = false;
          var gwpId = parseInt(gift.gift_variant_id, 10);
          if (gwpAllowed && gwpId > 0) {
            items.push({ id: gwpId, quantity: 1, properties: { '_gwp': 'true' } });
          }
        });
      }

      cta.setAttribute('data-loading', 'true');
      cta.setAttribute('disabled', 'disabled');

      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';

      var maybeOffer = (window.SvdUpsellPopup && typeof window.SvdUpsellPopup.offer === 'function')
        ? window.SvdUpsellPopup.offer()
        : Promise.resolve([]);

      maybeOffer
        .then(function (upsellIds) {
          (upsellIds || []).forEach(function (uid) {
            var pid = parseInt(uid, 10);
            if (pid > 0) items.push({ id: pid, quantity: 1, properties: { '_popup_deal': '1' } });
          });
          var svdRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return fetch(svdRoot + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items,
              sections: wantedSections,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e && e.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          try { root.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
          if (hasUpCart()) {
            renderDrawerSections(response);
            tryOpenUpCart();
          } else if (document.getElementById('SvdNotis')) {
            /* SVD Notis-sektionen visar bekräftelsen (fångar /cart/add-anropet själv). */
          } else if (!openThemeCartDrawer(response)) {
            window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          }
        })
        .catch(function (err) {
          console.error('[svd-bundle-v3] add-to-cart error', err);
          alert('Något gick fel. Försök igen.');
        })
        .finally(function () {
          cta.removeAttribute('data-loading');
          cta.removeAttribute('disabled');
        });
    }

    variants.forEach(function (v) {
      v.addEventListener('click', function (e) {
        if (v.getAttribute('data-available') === 'false') {
          e.preventDefault();
          return;
        }
        selectVariant(v);
      });
      var radio = v.querySelector('[data-bundle-radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          selectVariant(v);
        });
      }
    });

    cta.addEventListener('click', addToCart);
  }

  function mountAll() {
    var roots = document.querySelectorAll('.svd-b3');
    Array.prototype.forEach.call(roots, initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:block:select', mountAll);
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('.svd-b3'), initBundle);
  });
})();
